module.exports = __webpack_public_path__ + "static/play-video-0cf8e897372f7848635ceba8ab0dbab4.png";